import { useCallback } from 'react';
import { userOrdersApi } from '../../services/userOrdersApi';

/**
 * User Order Statistics Hook
 * Handles user order statistics and analytics
 */

// interface UseUserOrderStatsProps {
//   userId: number | null;
//   orderState: any;
// }

export const useUserOrderStats = (userId: number | null, setStats: any) => {
  // Fetch user order statistics
  const fetchOrderStats = useCallback(async () => {
    if (!userId) {
      return;
    }

    try {
      const orderStats = await userOrdersApi.getUserOrderStats(userId);
      // Ensure data types are safe
      setStats({
        total_orders: Number(orderStats.total_orders) || 0,
        pending_orders: Number(orderStats.pending_orders) || 0,
        preparing_orders: Number(orderStats.preparing_orders) || 0,
        on_the_way_orders: Number(orderStats.on_the_way_orders) || 0,
        completed_orders: Number(orderStats.completed_orders) || 0,
        total_spent: Number(orderStats.total_spent) || 0,
      });
    } catch (err) {
      console.error('Sipariş istatistikleri yüklenemedi:', err);
    }
  }, [userId, setStats]);

  return {
    fetchOrderStats,
  };
};
